import 'babel-polyfill'
import Vue from 'vue'
import i18n from '@/i18n' // should be included, probably (unless you're not using i18n translations in any components that will be loaded here)
import { VPopover, VTooltip } from 'v-tooltip'
import globalVue from '@/mixins/global'
import customMessage from '@/components/base/flash-message-custom/custom-message'
import FlashMessage from '@smartweb/vue-flash-message'
import baseFullLoader from '@/components/base/base-full-loader'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import loaderFull from '@/components/base/loader/base-full-loader-plugin'
import '@/config/validation/vee-validate-config' // include if needed, for example if you have any input form that needs to be validated
import lazyImage from '@/directives/lazyImage'
require('@/assets/styles/main.scss')

// require('@/config/axios') // include if needed, probably is

Vue.config.productionTip = false

/**
 * If you copy this to another entry point, check if you're using proper element id in spark templates
 */
Vue.component('v-popover', VPopover)
Vue.directive('tooltip', VTooltip)
Vue.component('customMessage', customMessage)
Vue.component('baseFullLoader', baseFullLoader)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(FlashMessage)
Vue.use(loaderFull)
Vue.mixin(globalVue)

Vue.use(lazyImage, {
  loading: '/assets/images/product_placeholder.png',
  error: '/assets/images/product_placeholder.png',
  root: document.getElementById('scrolling-container'), // defaults to html
  rootMargin: 0,
  threshold: 0
})

if (document.getElementById('hc-vue')) {
  const requireComponent = require.context('./views/', false, /view-[^\\]*\.vue$/)
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1') // TODO Normalize component names
    Vue.component(componentName, componentConfig.default || componentConfig)
  })

  new Vue({
    i18n,
    el: '#hc-vue'
  }).$mount('#hc-vue')
}
